import React from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";

const Team = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
          autoplay: true,
          arrow: false,
          autoplaySpeed: 2000,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          arrow: false,
          autoplaySpeed: 2000,
        },
      },
    ],
  };
  return (
    <section class="about-final">
      <div class="container">

        <h1>About Us</h1>
        <p class="tagline">Transforming Aluminum Scrap into Valuable Resources</p>

        <div class="about-wrapper">

          <div class="about-text">
            <h2>Who We Are</h2>
            <p>
              We are a dedicated aluminum scrap processing company committed to delivering high-quality recycled aluminum.
              With advanced furnace technology and a skilled workforce, we efficiently convert scrap into reusable metal
              for various industrial applications.
            </p>

            <h2>Our Operations</h2>
            <p>
              Our facility is equipped with modern melting furnaces designed for efficient and controlled aluminum processing.
              We handle different types of aluminum scrap and ensure consistent quality output while maintaining safety
              and environmental standards.
            </p>

            <h2>Why Choose Us</h2>
            <ul>
              <li>✔ Advanced furnace technology</li>
              <li>✔ Consistent material quality</li>
              <li>✔ Reliable supply chain</li>
              <li>✔ Focus on sustainable recycling</li>
            </ul>
          </div>

          <div class="about-image">
            <img src="furnace.jpg" alt="Aluminum Furnace" />
          </div>

        </div>

      </div>
    </section>
  );
};

export default Team;
